import * as THREE from 'three'
import { Vector3 } from 'three'
import TimeManager from '../../Utils/TimeManager'

export default class LabelManager
{
    constructor(scene, data) 
    {
        this.scene = scene
        this.data = data
        this.points = []

        this.scene.time.on('tick', () =>
        {
            this.update()
        })
    }

    update() {
        for(const point of this.points)
        {
            let edgeWorldPosition = new THREE.Vector3(0,0,0)
            point.node.edgePosition.getWorldPosition(edgeWorldPosition)
            edgeWorldPosition.add(new THREE.Vector3(0,point.node.labelOffset,0))
            edgeWorldPosition.project(this.scene.camera)
            const translateX = edgeWorldPosition.x * this.scene.sizes.width * 0.5
            const translateY = - edgeWorldPosition.y * this.scene.sizes.height * 0.5
            point.element.style.transform = `translateX(${translateX}px) translateY(${translateY}px)`
        }
    }

    createLabel(node) {
            const div1 = document.createElement('div');
            div1.className = "point pointA"
            div1.innerHTML = `<div class="bullet"></div><div class="label">`+node.data.name+`</div>`
            document.body.appendChild(div1);
            const newPoint = {
                node: node,
                element: div1
            }
            this.points.push(newPoint)
            node.htmllabel = newPoint
            if (node.type == "major_project") node.labelOffset = 0.04
            else node.labelOffset = 0.055
            this.createLine(node)
    }

    createLine(node) {
        const material = new THREE.LineBasicMaterial({color: "white"})
        material.side = THREE.DoubleSide
        material.transparent = true
        material.opacity = 0.3
        let points = []
        let geometry = null
        const pointA = node.edgePosition.position
        const pointB = new THREE.Vector3(0,0,0)
        pointB.copy(pointA)
        if (node.type == "major_project") pointB.add(new Vector3(0,node.labelOffset*0.55, 0))
        else pointB.add(new Vector3(0,node.labelOffset,0))

        points.push( pointA)
        points.push( pointB)
        geometry = new THREE.BufferGeometry().setFromPoints( points )
        const line = new THREE.Line( geometry, material )
        node.lineObject = line
        node.threeObject.add(line)
    }
}